import { MinLength } from 'class-validator';
export class Averias {
    public Nombre: string;
    public Nif: string;
    public EMail: string;
    public Telefono: string;
    public Contrato: number;
    public FechaEnvioAveria: string;
    public Extension: string;
    public Fichero: string;
    public ModoTest: boolean;
    public AveriaEn: string;
    public DireccionAveria: string;
    @MinLength(1)
    public TipoAveria: string;
    @MinLength(20, { message: 'La descripción debe tener al menos $constraint1 caracteres, actualmente tiene $value' })
    public DescAveria: string;
    public lat: number;
    public lng: number;
    public gRecaptchaResponse: string;
}
